import { transactionCoverage as ISDATransactionCoverage, repoTransactionCoverage } from '../../instances/store';
import { GMRANettingEngineData, ISDANettingEngineData } from './types';

export const ISDAProductsTradedOptions = ISDATransactionCoverage.standardOptions
    .filter(option => option.label !== 'Other')
    .map(option => option.label);

export const GMRAProductsTradedOptions = repoTransactionCoverage.standardOptions
    .filter(option => option.label !== 'Other')
    .map(option => option.label);

export const initialISDANettingEngineData: ISDANettingEngineData = {
    counterpartyNameKnown: null,
    counterparty: { entityId: null, jurisdiction: null, counterpartyClassification: null, subCounterpartyTypeId: null },
    agreement: null,
    governingLaw: null,
    productTypesKnown: null,
    productsTraded: [],
    counterpartyIsMultiBranch: null,
    counterpartyOffices: []
};

export const initialGMRANettingEngineData: GMRANettingEngineData = {
    counterpartyNameKnown: null,
    counterparty: { entityId: null, jurisdiction: null, counterpartyClassification: null, subCounterpartyTypeId: null },
    agreement: null,
    productTypesKnown: null,
    productsTraded: [],
    counterpartyOffices: [],
    counterpartyIsMultiDesignatedCities: null
};
